/**
 * Circular progress ring + "done/total" label for a signal's action checklist.
 * Mirrors the inline progress indicator in the redesigned signal cards.
 *
 * @param {number} completed - Number of completed (or won't-do) actions
 * @param {number} total     - Total number of actions
 * @param {number} [size]    - Ring diameter in px (default 16)
 */
export const SignalProgressRing = ({ completed, total, size = 16 }) => {
  const pct = total > 0 ? completed / total : 0;
  const allDone = total > 0 && completed >= total;
  const radius = (size - 3) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = circumference * pct;

  return (
    <div className="flex shrink-0 items-center gap-1.5">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="shrink-0 -rotate-90"
        aria-hidden="true"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={2}
          className="stroke-gray-200"
        />
        {total > 0 && pct > 0 && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            strokeWidth={2}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${circumference}`}
            className={allDone ? "stroke-emerald-500" : "stroke-emerald-400"}
          />
        )}
      </svg>
      <span className="whitespace-nowrap text-[11px] tabular-nums text-gray-500">
        {completed}/{total}
      </span>
      <div className="hidden h-2 w-32 overflow-hidden rounded-full bg-gray-100 sm:block">
        <div
          className="h-full rounded-full bg-emerald-500 transition-all"
          style={{ width: `${pct * 100}%` }}
        />
      </div>
    </div>
  );
};
